import "./EventOrganizerFilter.scss";
import moment from "moment";

export default {
  name: "EventOrganizerFilter",
  props: ["filter", "cities"],
  data: () => ({
    categoryEvents: [
      { title: "Alle Kategorien", value: "all" },
      { title: "Standorte", value: "location" },
      { title: "Veranstalter", value: "operator" }
    ],
    dialog: false,
    radios: [
      {
        title: "Alle Kategorien",
        value: "all"
      },
      {
        title: "Standorte",
        value: "location"
      },
      {
        title: "Veranstalter",
        value: "operator"
      }
    ],
    moment
  }),
  methods: {
    applySearchText() {
      if (!this.filter.s.length || this.filter.s.length >= 3)
        this.$emit("applyFilter", this.filter);
    },
    async resetFilter() {
      await this.$emit("resetFilter");
      this.featureListKey += 1;
    }
  },
  computed: {
    subPrincipals() {
      let selectablePrincipals = [this.$store.state.selectedPrincipal];
      this.$store.state.selectedPrincipal.subPrincipals.forEach(principal => {
        selectablePrincipals.push(principal);
      });
      return selectablePrincipals;
    }
  }
};
